module.exports = __webpack_public_path__ + "img/an.db0e9b8.svg";